// extracted by mini-css-extract-plugin
export default {"button":"button_button__ZFPs5","button__outline":"button_button__outline__kvUOJ","button__primary":"button_button__primary__6ihUd","icon":"button_icon__uirSY"};